import * as React from "react";
import {
  Box,
  Container,
  Grid,
  Heading,
  Stack,
  Text,
  Input,
  Textarea,
  Field,
  chakra,
} from "@chakra-ui/react";
import { FiMapPin, FiMail, FiPhone } from "react-icons/fi";
import Header from "components/reusables/Header/Header";
import Footer from "../Footer/Footer";
import CustomButton from "layouts/CustomButton/CustomButton";

const ContactUs: React.FC = () => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  return (
    <>
      <Header />
      <Box
        bg="white"
        pt={{ base: 24, md: 28 }}
        pb={{ base: 12, md: 20 }}
        minH="100vh"
      >
        <Container maxW="6xl">
          <Heading
            as="h2"
            size="2xl"
            textAlign="center"
            mb={12}
            color="blue.600"
          >
            Contact Us
          </Heading>

          <Grid templateColumns={{ base: "1fr", md: "1fr 1.5fr" }} gap={10}>
            {/* LEFT: info section */}
            <Box
              bg="white"
              borderRadius="2xl"
              boxShadow="none"
              p={{ base: 8, md: 10 }}
              height="fit-content"
              border="1px solid"
              borderColor="gray.100"
            >
              <Stack gap={8}>
                <Box>
                  <Heading size="md" mb={6} color="gray.800">
                    Contact Information
                  </Heading>
                  <Stack gap={6}>
                    <Box display="flex" gap={4}>
                      <Box as={FiMapPin} boxSize={6} color="blue.500" mt={1} />
                      <Box>
                        <Text fontWeight="bold" color="gray.800" mb={1}>
                          Location
                        </Text>
                        <Text fontSize="md" color="gray.600">
                          Webtooth Techno LLP <br />
                          Sector-49 Gurugram, Haryana
                        </Text>
                      </Box>
                    </Box>

                    <Box display="flex" gap={4}>
                      <Box as={FiMail} boxSize={6} color="blue.500" mt={1} />
                      <Box>
                        <Text fontWeight="bold" color="gray.800" mb={1}>
                          Email
                        </Text>
                        <Text fontSize="md" color="gray.600">
                          connect@cashquin.com
                        </Text>
                      </Box>
                    </Box>

                    <Box display="flex" gap={4}>
                      <Box as={FiPhone} boxSize={6} color="blue.500" mt={1} />
                      <Box>
                        <Text fontWeight="bold" color="gray.800" mb={1}>
                          Phone
                        </Text>
                        <Text fontSize="md" color="gray.600">
                          +91 9511520346
                        </Text>
                      </Box>
                    </Box>
                  </Stack>
                </Box>
              </Stack>
            </Box>

            {/* RIGHT: form section */}
            <chakra.form
              onSubmit={handleSubmit}
              bg="white"
              borderRadius="2xl"
              boxShadow="none"
              p={{ base: 8, md: 10 }}
              border="1px solid"
              borderColor="gray.100"
            >
              <Heading as="h3" size="lg" mb={8} color="gray.800">
                Get in touch
              </Heading>

              <Stack gap={6}>
                <Field.Root required>
                  <Field.Label color="gray.700" fontWeight="medium">
                    Name
                  </Field.Label>
                  <Input
                    name="name"
                    placeholder="Enter your name"
                    size="lg"
                    borderRadius="lg"
                    bg="gray.50"
                  />
                </Field.Root>

                <Field.Root required>
                  <Field.Label color="gray.700" fontWeight="medium">
                    Mobile number
                  </Field.Label>
                  <Input
                    name="mobile"
                    type="tel"
                    placeholder="Enter your mobile number"
                    size="lg"
                    borderRadius="lg"
                    bg="gray.50"
                  />
                </Field.Root>

                <Field.Root required>
                  <Field.Label color="gray.700" fontWeight="medium">
                    Email address
                  </Field.Label>
                  <Input
                    name="email"
                    type="email"
                    placeholder="Enter your email"
                    size="lg"
                    borderRadius="lg"
                    bg="gray.50"
                  />
                </Field.Root>

                <Field.Root>
                  <Field.Label color="gray.700" fontWeight="medium">
                    Drop message
                  </Field.Label>
                  <Textarea
                    name="notes"
                    rows={5}
                    placeholder="Write your message / notes here"
                    size="lg"
                    borderRadius="lg"
                    bg="gray.50"
                  />
                </Field.Root>

                <Box mt={4}>
                  <CustomButton
                    type="submit"
                    colorPalette="blue"
                    width="full"
                    size="lg"
                  >
                    Send Message
                  </CustomButton>
                </Box>
              </Stack>
            </chakra.form>
          </Grid>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default ContactUs;
